export default function getFilenameExtension(filename) {
    return filename.split('.').pop();
}
